/**
 * Created by 马荣钦 on 2016/1/21.
 */
angular
    .module('myZonePersonalInfoModule', [
        'myZonePersonalInfoRouterModule',
        'myZonePersonalInfoLeftModule',
        'myZonePerInfoInfoModule',
        'myZonePerInfoPerSettingModule',
        'myZonePerInfoChangePwdModule',
        'myZonePerPerferenceConfigModule', // 个人喜好设置模块
    ])
    .controller('myZonePersonalInfoCtrl', ['$scope', function ($scope) { }]);
